import EmailLanguage from './EmailLanguage';

export default EmailLanguage;
